export default __webpack_public_path__ + "images/SpeakersPhotos/Luis Diaz del Dedo_ Product Hackers.jpg?96b29325";